import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const deactivateAccount = async (deactivateAccount) => {
  try {
    const result = await fetch(
      `${hostName}/business/account-deactivate-account`,
      {
        method: "POST",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(deactivateAccount),
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
